module.exports = __webpack_public_path__ + "static/img/teamHonorBg2.54f662fd.png";